export default "__VITE_ASSET__CT8X_N6i__"